import {Component, Input} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {BarcodeFormat} from "@zxing/library";
import {ToastService} from "../../services/core/toast.service";

// scans one code in the browser without leaving the current page (in the app the native scanner is used, see ScannerService.scanCode)
@Component({
  selector: 'app-barcode-scan-modal',
  templateUrl: './barcode-scan-modal.page.html',
  styleUrls: ['./barcode-scan-modal.page.scss'],
})
export class BarcodeScanModalPage {

  @Input() Title: string = 'Scannen';

  formats: BarcodeFormat[] = [
    BarcodeFormat.EAN_13,
    BarcodeFormat.EAN_8,
    BarcodeFormat.UPC_A,
    BarcodeFormat.UPC_E,
    BarcodeFormat.CODE_128
  ];
  camera: MediaDeviceInfo;
  codeInput: string;
  scanned: boolean = false;

  constructor(
    private modalController: ModalController,
    private toastService: ToastService
  ) { }

  camerasFound(devices: MediaDeviceInfo[]) {
    // the back camera, if there is one
    this.camera = (devices || []).find(device => /back|rear|environment|rück/i.test(device.label)) || (devices || [])[0];
  }

  async setPermission(permission: boolean) {
    if (permission === false) {
      await this.toastService.presentError('Die Kamera muss aktiviert und zugelassen werden.');
    }
  }

  scanSuccess(code: string) {
    if (!code || this.scanned) {
      return;
    }
    this.scanned = true;
    return this.modalController.dismiss({ Code: code.trim() });
  }

  close() {
    return this.modalController.dismiss({ Code: null });
  }
}
